// extracted by mini-css-extract-plugin
export default {"select":"select_select__MfhoY","icon":"select_icon__pz7wE","disabled":"select_disabled__yw-JN","noSelection":"select_noSelection__ZGhLs"};